import * as React from 'react'

import { styled, theme } from '../theme'

export interface NotFoundItemProps {
  className?: string
  mainTitle?: string
}

export class NotFoundItem extends React.Component<NotFoundItemProps, {}> {
  render() {
    const {
      mainTitle = '404. Taki obiekt nie został znaleziony. Być może został usunięty.',
      children,
      className,
    } = this.props
    return (
      <Wrapper className={className}>
        <Title>{mainTitle}</Title>
        {children && <Children>{children}</Children>}
      </Wrapper>
    )
  }
}

const Wrapper = styled.div``
const Title = styled.h3`
  margin-bottom: ${theme.padding.default};
`
const Children = styled.div`
  padding: ${theme.padding.default};
`
